import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ptTranslation from './locales/pt/translation.json';

// Site comercial unico idioma (pt-BR). Mantido via i18next para facilitar a
// adicao de outros idiomas no futuro sem refatorar os componentes.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: ptTranslation },
    },
    fallbackLng: 'pt',
    supportedLngs: ['pt'],
    interpolation: { escapeValue: false },
  });

export default i18n;
